const configureTabs = ['overview'] as const
const collectTabs = ['landingPage', 'questions', 'dataCollection', 'successPage'] as const
const collaborateTabs = ['sharing', 'contest'] as const
const customizeTabs = ['videoLayout'] as const

export type ConfigureTab = typeof configureTabs[number]
export type CollectTab = typeof collectTabs[number]
export type CollaborateTab = typeof collaborateTabs[number]
export type CustomizeTab = typeof customizeTabs[number]
export type ProjectSectionTab = ConfigureTab | CollectTab | CollaborateTab | CustomizeTab

const isValidTab = (value: string | undefined, tabs: readonly string[]): value is string => !!value && tabs.includes(value)

export const isValidConfigureTab = (value: string | undefined): value is ConfigureTab => isValidTab(value, configureTabs)
export const isValidCollectTab = (value: string | undefined): value is CollectTab => isValidTab(value, collectTabs)
export const isValidCollaborateTab = (value: string | undefined): value is CollaborateTab => isValidTab(value, collaborateTabs)
export const isValidCustomizeTab = (value: string | undefined): value is CustomizeTab => isValidTab(value, customizeTabs)
export const isValidProjectSectionTab = (value: string | undefined): value is ProjectSectionTab => isValidTab(value, [...configureTabs, ...collectTabs, ...customizeTabs])
